<div class="on-top modal-resizable"
  #layerZIndex>
  <div [className]="isNonWindow || isFullPage ? 'detail-container full-page' : 'detail-container'"
    (mousedown)="onFocus()"
    #containerWindow>
    @if (!isNonWindow) {
      <mat-toolbar class="title"
        color="primary"
        (dblclick)="onFullPage()"
        [ngStyle]="{'background-color': headerColor}"
        (mousedown)="onStartMove($event)">
        <!-- START:ARROWS -->
        @if (!!arrowMetaData) {
          <div
            class="toolbar-actions"
            (mousedown)="$event.stopPropagation()"
            (mouseover)="_noLayout = true"
            (mouseout)="_noLayout = false">
            @if (arrowMetaData.isLeft) {
              <button mat-icon-button
                class="button-icon-right-top"
                (click)="clickArrowLeft($event)">
                <fa-icon icon="arrow-left"></fa-icon>
              </button>
            }
            @if (arrowMetaData.isRight) {
              <button mat-icon-button
                class="button-icon-right-top"
                (click)="clickArrowRight($event)">
                <fa-icon icon="arrow-right"></fa-icon>
              </button>
            }
          </div>
        }
        <!-- END:ARROWS -->
        <div class="toolbar-title"> {{ title }} </div>
        <div class="toolbar-actions"
          (mousedown)="$event.stopPropagation()"
          (mouseover)="_noLayout = true"
          (mouseout)="_noLayout = false">
          <button mat-icon-button
            type="button"
            (click)="onFullPage()">
            @if (!isFullPage) {
              <mat-icon>fullscreen</mat-icon>
            }
            @if (isFullPage) {
              <mat-icon>fullscreen_exit</mat-icon>
            }
          </button>
          <button mat-icon-button
            type="button"
            [hidden]="!isOutsideButton"
            (click)="newWindow()">
            <mat-icon>flip_to_front</mat-icon>
          </button>
          <button mat-icon-button
            type="button"
            (click)="onClose()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-toolbar>
    }
    <div class="inside-content">
      <div class="modal-body"
        (wheel)="onWheel($event)"
        #inWindow>
        <ng-content></ng-content>
      </div>
    </div>

    <!--
    Resizable conrols
    -->
    @for (item of ['left','right','bottom','top']; track item) {
      <div
        [className]="'resize '+item"
        (mousedown)="onResize($event, item)"
        (mouseup)="afterResize()">
      </div>
    }
    @for (item of ['tl','tr','bl','br']; track item) {
      <div
        [className]="'resize corner '+ item"
        (mousedown)="onResize($event, item)"
      (mouseup)="afterResize()"></div>
    }
  </div>
</div>

<app-window [isWindow]="__isBrowserWindow"
  [width]="width"
  [height]="height"
  [objectData]="objectData"
  [sharedUrl]="sharedUrl"
  (close)="onWindowClose($event)">

  <div class="out-window"
  #outWindow></div>

</app-window>